
const index = resolve => require(["@/pages/count/index/index.vue"], resolve);
const transaction = resolve => require(["@/pages/count/transaction/index.vue"], resolve);
const member = resolve => require(["@/pages/count/member/index.vue"], resolve);
const store = resolve => require(["@/pages/count/store/index.vue"], resolve);
const goods = resolve => require(["@/pages/count/goods/index.vue"], resolve);
const router = [{
    path: '/count/index',
    component: index,
}, {
    path: "/count/transaction",
    component: transaction,
}, {
    path: "/count/member",
    component: member,
}, {
    path: "/count/store",
    component: store,
}, {
    path: "/count/goods",
    component: goods,
}];

export default router;
